<template>
  <div v-if="title!=''" class="sub-nav">
    <span class="sub-nav-icon">
      <i class="cubeic-back" @click="goBack"></i>
    </span>
    <span class="sub-nav-title">{{title}}</span>
  </div>
</template>

<script>

export default {
  name: 'SubNav',
  props: {
    title: {
      type: String,
      default: '真源码'
    },
  },
  data() {
    return {
      metaTitle: this.title
    }
  },
  watch: {
    title(newValue, oldValue) {
      this.metaTitle = newValue;
    }
  },
  created () {
    // console.log(this.title);
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      // const path = this.$route.path;
      // this.$emit('child', path)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";
.sub-nav-title{
  letter-spacing: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/SubNav.vue